// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comm-channels {
  background:
    linear-gradient(180deg, rgba(15, 46, 36, 0.03), transparent 40%),
    transparent;
}

.comm-channels__intro {
  margin-bottom: clamp(2.25rem, 5vw, 3.25rem);
}

.comm-channels__list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.9rem;
}

.comm-channel {
  display: grid;
  justify-items: start;
  gap: 0.9rem;
  min-height: 100%;
  padding: 1.15rem 1.1rem 1.25rem;
  border: 1px solid var(--line);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.65);
}

.comm-channel__logo {
  width: auto;
  max-width: 7.5rem;
  height: 2.5rem;
  object-fit: contain;
  object-position: left center;
  border-radius: 4px;
  background: transparent;
}

.comm-channel__name {
  font-family: var(--font-display);
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--ink);
}

.comm-channel__text {
  margin-top: 0.35rem;
  font-size: 0.92rem;
  line-height: 1.4;
  color: var(--muted);
}

@media (max-width: 1100px) {
  .comm-channels__list {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 720px) {
  .comm-channels__list {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 480px) {
  .comm-channels__list {
    grid-template-columns: 1fr;
  }

  .comm-channel {
    grid-template-columns: auto 1fr;
    align-items: center;
    gap: 0.9rem 1rem;
  }

  .comm-channel__copy {
    grid-column: 2;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CommChannels.css"],"names":[],"mappings":"AAAA;EACE;;eAEa;AACf;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".comm-channels {\r\n  background:\r\n    linear-gradient(180deg, rgba(15, 46, 36, 0.03), transparent 40%),\r\n    transparent;\r\n}\r\n\r\n.comm-channels__intro {\r\n  margin-bottom: clamp(2.25rem, 5vw, 3.25rem);\r\n}\r\n\r\n.comm-channels__list {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 0.9rem;\r\n}\r\n\r\n.comm-channel {\r\n  display: grid;\r\n  justify-items: start;\r\n  gap: 0.9rem;\r\n  min-height: 100%;\r\n  padding: 1.15rem 1.1rem 1.25rem;\r\n  border: 1px solid var(--line);\r\n  border-radius: 6px;\r\n  background: rgba(255, 255, 255, 0.65);\r\n}\r\n\r\n.comm-channel__logo {\r\n  width: auto;\r\n  max-width: 7.5rem;\r\n  height: 2.5rem;\r\n  object-fit: contain;\r\n  object-position: left center;\r\n  border-radius: 4px;\r\n  background: transparent;\r\n}\r\n\r\n.comm-channel__name {\r\n  font-family: var(--font-display);\r\n  font-size: 1.05rem;\r\n  font-weight: 700;\r\n  letter-spacing: -0.01em;\r\n  color: var(--ink);\r\n}\r\n\r\n.comm-channel__text {\r\n  margin-top: 0.35rem;\r\n  font-size: 0.92rem;\r\n  line-height: 1.4;\r\n  color: var(--muted);\r\n}\r\n\r\n@media (max-width: 1100px) {\r\n  .comm-channels__list {\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n}\r\n\r\n@media (max-width: 720px) {\r\n  .comm-channels__list {\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .comm-channels__list {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .comm-channel {\r\n    grid-template-columns: auto 1fr;\r\n    align-items: center;\r\n    gap: 0.9rem 1rem;\r\n  }\r\n\r\n  .comm-channel__copy {\r\n    grid-column: 2;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
